/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { GEOS } from 'core/utils/constants';
import { HCP_EU_PRIVATE_BETA_MODAL_SEEN_KEY } from 'hcp/utils/constants';

// We are required to display the EU private beta modal until the product is generally available.
// This modal will be retired once the product is GA post October 1st, 2025 as part of
// https://hashicorp.atlassian.net/browse/HCPIE-2833
export default class HcpEuPrivateBetaModalComponent extends Component {
  @service config;
  @tracked showModal = false;

  constructor() {
    super(...arguments);

    const localStoragePrivateBetaModalKey = localStorage.getItem(
      HCP_EU_PRIVATE_BETA_MODAL_SEEN_KEY
    );

    this.showModal =
      this.config.app?.deployGeo === GEOS.EU &&
      !localStoragePrivateBetaModalKey;
  }

  @action
  close() {
    this.showModal = false;
    localStorage.setItem(HCP_EU_PRIVATE_BETA_MODAL_SEEN_KEY, true);
  }
}
